<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('png-to-pdf-converter', 'PNG → PDF');

function handleBatchCreated(batchId: string) {
  console.log('[PNG→PDF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[PNG→PDF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[PNG→PDF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[PNG→PDF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[PNG→PDF Converter] Credits updated:', credits);
}
</script>
